<header class="header" [style.background-color]="colors[theme].header_bg">
  <div class="container-logo" [style.background-color]="colors[theme].header_bg">
    <h1 class="logo" [style.background-color]="colors[theme].header_bg">
      <img src="assets/images/immersion_assets/Logo_Immersion1.png" alt="Analytiko" title="Analytiko"
        [style.background-color]="colors[theme].header_bg" />
    </h1>
  </div>

  <div class="container-options">
    <div class="content-config">
      <div class="menu-user">
        <ul class="list-user">
          <li>
            <a routerLink="/profile"><i class="fa fa-user"></i> Perfil</a>
          </li>

          <li>
            <a><i class="fa fa-power-off"></i> Salir</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>